import type { SlideFromBackend, SlidesFromBackend, TransformedSlides } from './types';

export function transformSlides(
  slides: SlidesFromBackend,
): TransformedSlides {
  return slides.data.map(({ id, attributes }) => createSlide(id, attributes));
}

function createSlide(
  id: SlideFromBackend['id'],
  attributes?: SlideFromBackend['attributes'],
) {
  return {
    id,
    content: attributes?.content || '',
    image: getImageUrl(attributes),
  };
}

function getImageUrl(attributes?: SlideFromBackend['attributes']) {
  const images = attributes?.image;

  if (!images) {
    return null;
  }

  return images?.small || images?.original || null;
}
